export const getLocation: () => Location = () => {
  if (import.meta.server) {
    // @ts-ignore
    return useRequestURL() as unknown as Location;
  }
  return window.location;
};
